<template>
    <app-modal-view @close="$emit('close')" class="shareModal">
        <template #header>
            <div class="header-project">
                <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt="eduloc360"
                    width="160"
                    height="50"
                />
                <!--<p
                    aria-label="close"
                    class="lb-modal-close has-text-white is-pulled-right"
                    @click="$emit('close')"
                >
                    <span class="icon is-large">
                        <i class="mdi mdi-close mdi-24px"></i>
                    </span>
                </p>-->
            </div>
        </template>
        <template #body>
            <div class="is-fullsize columns is-mobile">
                <div class="column secondary-font-semi">
                    {{$t('mobile_alert_title')}}
                </div>
            </div>
            <div class="is-fullsize columns is-mobile">
                <div class="column">
                    <div class="secondary-font">
                        {{$t('mobile_alert_download')}}
                    </div>
                    <div v-if="isAndroid" class="pt-4">
                        <a href="http://play.google.com/store/apps/details?id=com.itinerarium.eduloc360" class="button is-primary is-fullwidth">{{$t('mobile_alert_download_button_android')}}</a> 
                    </div>
                    <div v-if="isIOS" class="pt-4">
                        <a href="https://apps.apple.com/es/app/eduloc360/id1167553430" class="button is-primary is-fullwidth">{{$t('mobile_alert_download_button_ios')}}</a>
                    </div>
                </div>
                
            </div>

            <div class="is-fullsize columns is-mobile">
                <div class="column">
                    <div class="secondary-font">
                        {{$t('mobile_alert_run_app')}}
                    </div>
                    <div class="pt-4">
                        <a href="eduloc360://" class="button is-primary is-fullwidth">{{$t('mobile_alert_open_app')}}</a> 
                    </div>

                </div>
                
            </div>

            
        </template>
    </app-modal-view>
    
</template>

<script>
import AppModalView from '@/components/AppModalView';

export default {
    components: {
        AppModalView
    },
    props: {
        
        isAndroid: {
            type: Boolean,
            default: false,
        },
        isIOS: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
        };
    },
    
    computed: {
        
    },
    methods: {
        
    },
    async mounted() {
        
    },
};
</script>

<style scoped>
    @import '../assets/css/project-modal-share.css';
    .shareModal /deep/ .modal-card-head{
        background-color: var(--eduloc-red)
    }
</style>
